import type { FC } from 'react'

import { Td } from '@skytech/ui/Table/Td'
import { TrButton } from '@skytech/ui/Table/TrButton'
import GlobeIcon from 'mdi-react/GlobeIcon'
import PinIcon from 'mdi-react/PinIcon'

import { useTranslation } from '@/app/translations/translations-hooks'
import Highlight from '@/components/Highlight'
import { useFormattedNumber } from '@/hooks/use-formatted-number'
import { useFormattedNumberWithCurrency } from '@/hooks/use-formatted-number-with-currency'

import type { SalaryDeductionProfile } from '../resources'

export const TelePoliciesListItem: FC<
  SalaryDeductionProfile & {
    searchFilter: string
    onEdit: () => void
  }
> = ({
  name,
  freeAllowanceAmount,
  telePolicyTemplate,
  searchFilter,
  onEdit,
  customer,
  customerHead,
  subscribers,
}) => {
  const translate = useTranslation()
  const { formatNumber: formatNumberWithCurrency } = useFormattedNumberWithCurrency()
  const { formatNumber } = useFormattedNumber()

  const currency = customerHead?.corporateCustomer?.country?.currency || customer?.country?.currency

  return (
    <TrButton onClick={onEdit}>
      <Td>
        <Highlight pattern={searchFilter} text={name} />
      </Td>

      <Td>
        <Highlight pattern={searchFilter} text={telePolicyTemplate?.name} />
      </Td>

      <Td>
        <div className="flex items-center gap-x-2">
          <Highlight
            pattern={searchFilter}
            text={customerHead?.id ? translate('Global') : translate('Local')}
          />

          {customerHead?.id ? (
            <GlobeIcon className="h-4 w-4 fill-gray-500" />
          ) : (
            <PinIcon className="h-4 w-4 fill-gray-500" />
          )}
        </div>
        <div className="text-sm text-gray-400">
          <Highlight
            pattern={searchFilter}
            text={customerHead?.id ? customerHead?.name : customer?.name}
          />
        </div>
      </Td>

      <Td className="text-right">
        <Highlight
          pattern={searchFilter}
          text={formatNumberWithCurrency({ amount: Number(freeAllowanceAmount), currency })}
        />
      </Td>

      <Td className="text-right">
        <Highlight pattern={searchFilter} text={formatNumber({ amount: Number(subscribers) })} />
      </Td>
    </TrButton>
  )
}
